import { useEffect, useRef, useState } from "react";

function PickleballCursor({ innerRef }) {
  return (
    <svg viewBox="0 0 24 24" className="h-full w-full drop-shadow-[0_2px_8px_rgba(132,204,22,0.5)]">
      <circle cx="12" cy="12" r="10" fill="#84CC16" />
      <circle cx="8.5" cy="8.5" r="1.5" fill="#07090E" />
      <circle cx="14.5" cy="7.5" r="1.5" fill="#07090E" />
      <circle cx="12" cy="12.5" r="1.5" fill="#07090E" />
      <circle cx="17" cy="12.5" r="1.5" fill="#07090E" />
      <circle cx="6.5" cy="13.5" r="1.5" fill="#07090E" />
    </svg>
  );
}

export default function CustomCursor() {
  const ballRef = useRef(null);
  const ringRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    document.body.classList.add("custom-cursor");

    const pos = { x: -100, y: -100 };
    const ring = { x: -100, y: -100 };
    let hovering = false;
    let visible = false;
    let raf;

    const onMove = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
      if (!visible) {
        visible = true;
        if (ballRef.current) ballRef.current.style.opacity = "1";
        if (ringRef.current) ringRef.current.style.opacity = "1";
      }
    };
    const onOver = (e) => {
      hovering = !!(
        e.target.closest &&
        e.target.closest("a, button, select, input[type=checkbox], [role=button]")
      );
    };
    const onLeave = () => {
      visible = false;
      if (ballRef.current) ballRef.current.style.opacity = "0";
      if (ringRef.current) ringRef.current.style.opacity = "0";
    };

    const loop = () => {
      ring.x += (pos.x - ring.x) * 0.16;
      ring.y += (pos.y - ring.y) * 0.16;
      if (ballRef.current) {
        ballRef.current.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0) translate(-50%, -50%) scale(${hovering ? 0.55 : 1})`;
      }
      if (ringRef.current) {
        ringRef.current.style.transform = `translate3d(${ring.x}px, ${ring.y}px, 0) translate(-50%, -50%) scale(${hovering ? 1.7 : 1})`;
      }
      raf = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);
    document.documentElement.addEventListener("mouseleave", onLeave);
    raf = requestAnimationFrame(loop);

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      document.documentElement.removeEventListener("mouseleave", onLeave);
      cancelAnimationFrame(raf);
      document.body.classList.remove("custom-cursor");
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      <div
        ref={ringRef}
        className="pointer-events-none fixed left-0 top-0 z-[99] h-9 w-9 rounded-full border border-volt/50 opacity-0 will-change-transform"
        data-testid="custom-cursor-ring"
        aria-hidden="true"
      />
      <div
        ref={ballRef}
        className="pointer-events-none fixed left-0 top-0 z-[100] h-5 w-5 opacity-0 will-change-transform"
        data-testid="custom-cursor-ball"
        aria-hidden="true"
      >
        <PickleballCursor innerRef={ballRef} />
      </div>
    </>
  );
}
